import styled from 'styled-components';
import { ThemedComponent } from '@la/ds-ui-components';

type ComposedHeaderStyleProps = ThemedComponent<{
  $isTabletLandscapeUp: boolean;
}>;

export const ComposedHeaderDate = styled.div<ComposedHeaderStyleProps>(
  ({ theme, $isTabletLandscapeUp }: ComposedHeaderStyleProps) => {
    const font = $isTabletLandscapeUp
      ? theme.typography.ui.xl
      : theme.typography.ui.large;
    return {
      ...font,
      display: 'flex',
      alignItems: 'center',
      gap: '4px',

      '& > svg': {
        flexShrink: 0,
      },
    };
  }
);

export const TitleContainer = styled.div<{ $isTabletLandscapeUp: boolean }>(
  ({ $isTabletLandscapeUp }) => {
    return {
      display: 'flex',
      alignItems: $isTabletLandscapeUp ? 'flex-end' : 'flex-start',
      gap: $isTabletLandscapeUp ? '16px' : '4px',
      flexDirection: $isTabletLandscapeUp ? 'row' : 'column',

      'p, h1': {
        color: 'white',
      },
    };
  }
);

export const PriceBullet = styled.span({
  margin: '0 8px',
});
